/* istanbul ignore file -- browser worker bootstrap wrapper around search worker construction */

export const getSearchIndexWorker = (): Worker =>
  new Worker(new URL('../../searchWorker', import.meta.url), {
    type: 'module',
  });
